module.exports = __webpack_public_path__ + "assets/media/day34.ab3855b4.mp3";